import React from 'react';
import add from "../../Assets/Collect Offer Related Doc.svg";
import { Button } from "@mui/material";
import { Clear, Search } from "@mui/icons-material";
import { FaPlus } from "react-icons/fa";

const ListTable = ({handleListClick,template,task,searchText,handleSearch,handleSearchClear}) => {

return (
  <>
  <style>
        {`
          input::placeholder {
            color: #cfd4e9;
          }
        `}
      </style>

 <div
 style={{
   display: "flex",
   justifyContent: "space-between",
   alignItems: "center",
   margin: "20px",
   marginRight:"40px",
   marginLeft:"35px",
   cursor: "pointer",
 }}
>
<div style={{display:'flex',justifyContent:'space-between',alignItems:'center',border:'1px solid #cfd4e9',borderRadius:'4px',opacity:1}}>
<input
   type="text"
   placeholder="Search..."
   value={searchText}
    onChange={handleSearch}
   style={{ height: "38px", width: "270px" ,border:'none',borderRadius:'4px',outline:'none',}}
 />
   {(searchText === ''|| searchText === undefined) ? <Search style={{color:'#757ea5'}}/> : <Clear style={{color:'#757eas'}} onClick={handleSearchClear} sx={{cursor:'pointer'}}/>}
</div>
 
 {template &&
 <Button
   variant="contained"
   startIcon={<FaPlus size={15}/>}
  //  startIcon={<img src={add} alt="add" size={25} />}
   style={{ backgroundColor: "#02acf6", textTransform: 'none', fontWeight:600,boxShadow:'none'}}
   onClick={handleListClick}
 >
   Create
 </Button>}
</div>
 
  </>
  )
}

export default ListTable
